import { render } from "./BaseTable4.vue?vue&type=template&id=bbdc5ce4&scoped=true"
import script from "./BaseTable4.vue?vue&type=script&lang=js"
export * from "./BaseTable4.vue?vue&type=script&lang=js"

import "./BaseTable4.vue?vue&type=style&index=0&id=bbdc5ce4&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbdc5ce4"]])

export default __exports__